import React, { useEffect, useMemo, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';

import { Reveal } from '../../../../components/Reveal/Reveal';
import { SectionHeader } from '../../../../components/SectionHeader/SectionHeader';

import astantinPhoto from '../../../../assets/persons/Астанин/Астанин А.В..png';
import vladzimirskyPhoto from '../../../../assets/persons/Владзимирский/photo.png';
import gusevPhoto from '../../../../assets/persons/Гусев/Гусев А.В..png';
import likutovPhoto from '../../../../assets/persons/Ликутов/Ликутов Алексей Александрович.png';
import lychagovPhoto from '../../../../assets/persons/Лычагов/Лычагов Александр Николаевич.png';
import meshcheryakovaPhoto from '../../../../assets/persons/Мещерякова/Мещерякова А.М..png';
import chuprovPhoto from '../../../../assets/persons/Чупров/Чупров А.В..png';
import khokhlovPhoto from '../../../../assets/persons/Хохлов/Хохлов А.Л..png';
import udinPhoto from '../../../../assets/persons/Юдин/Юдин Илья Викторович.png';
import kobyakovaPhoto from '../../../../assets/persons/Кобякова/Кобякова Е.А..png';
import fursovPhoto from '../../../../assets/persons/Фурсов/Фурсов К.С..jpg';

import ui from '../../../../styles/ui.module.css';
import st from './Speakers.module.css';

const speakers = [
    {
    id: 'vladzimirsky',
    name: 'Владзимирский Антон Вячеславович',
    role: 'Заместитель директора по научной работе, доктор медицинских наук, доцент',
    org: 'Научно-практический клинический центр диагностики и телемедицинских технологий ДЗМ',
    summary:
      'В основе каждого явления в медицине лежит наука. На лекциях разбирается крупнейшее в мире научное исследование о применимости, безопасности и качестве искусственного интеллекта.',
    photo: vladzimirskyPhoto,
  },
  {
    id: 'gusev',
    name: 'Гусев Александр Владимирович',
    role: 'к.т.н., директор по развитию Webiomed',
    org: 'Эксперт по ИИ ЦНИИОИЗ Минздрава России',
    summary:
      'Лекции формируют современное и адекватное представление о возможностях ИИ, его трендах, эффектах и рисках в реальной клинической практике.',
    details:
      'Курс помогает увидеть ИИ как практический инструмент для врачей, управленцев здравоохранения и пациентов.',
    photo: gusevPhoto,
  },
  {
    id: 'likutov',
    name: 'Ликутов Алексей Александрович',
    role: 'К.м.н., Руководитель отдела эндоскопической хирургии и диагностики ФГБУ «НМИЦ колопроктологии имени А.Н. Рыжих» Минздрава России',
    org: 'ФГБУ «НМИЦ колопроктологии имени А.Н. Рыжих» Минздрава России',
    summary:
      'В рамках занятий разбираются критерии качества колоноскопии, мировой и российский опыт применения ИИ в колоноскопии, а также перспективы использования ИИ в работе врача.',
    details:
      'Спикер делится практикой проектирования собственных решений и подходами к их внедрению.',
    photo: likutovPhoto,
  },
  {
    id: 'lychagov',
    name: 'Лычагов Александр Николаевич',
    role: 'Заместитель директора по проектной деятельности',
    org: 'ГБУЗ «Челябинский областной медицинский информационно-аналитический центр»',
    summary:
      'На лекции подробно разбирается практическая работа с федеральными регистрами медицинских организаций и работников, а также разделом «Оборудование».',
    details:
      'Отдельный акцент сделан на типовых ошибках при выверке цифрового рентгеновского оборудования в рамках Инцидента № 11 и способах их избежать.',
    photo: lychagovPhoto,
  },
  {
    id: 'meshcheryakova',
    name: 'Мещерякова Анна Михайловна',
    role: 'Генеральный директор компании «Платформа Третье Мнение»',
    summary:
      'Этика и безопасность пациентов остаются приоритетом на всех этапах внедрения ИИ-решений. Лекции дают всесторонний обзор применения чат-ботов и ключевых сценариев использования ИИ в российском здравоохранении.',
    details:
      'Отдельный блок посвящен нормативно-правовому регулированию, регистрации и пострегистрационному клиническому мониторингу медицинских изделий с ИИ.',
    photo: meshcheryakovaPhoto,
  },
  {
    id: 'udin',
    name: 'Юдин Илья Викторович',
    role: 'Начальник управления единой государственной информационной системы здравоохранения',
    org: 'Министерство здравоохранения Челябинской области',
    summary:
      'Изучим инфраструктуры ГИС СЗ и ЦАМИ, аппаратном обеспечении центра обработки данных, клиник, а также об организации защищённых каналов связи на примере Челябинской области. Рассмотрим технические и организационные факторы, затрудняющие максимально эффективное применение ЦАМИ медицинскими организациями. Кроме того, затрагиваются вопросы обеспечения информационной безопасности и соблюдения требований ФСТЭК и ФСБ России.',
    photo: udinPhoto,
  },
  {
    id: 'kobyakova',
    name: 'Кобякова Екатерина Алексеевна',
    role: 'Генеральный директор группы компаний "Эрна"',
    summary:
        'Лекция посвящена внедрению ИИ-решений в кардиологию: его возможностям, задачам и тому, как он помогает в диагностике и обработке медицинских данных.',
    photo: kobyakovaPhoto,
  },
  {
    id: 'astanin',
    name: 'Астанин Анатолий Владимирович',
    role: 'Data Scientist',
    org: 'Центр развития искусственного интеллекта Пироговского Университета',
    summary:
        'Курс охватывает полный цикл создания медицинских ИИ-систем: от математических основ машинного обучения и архитектуры нейронных сетей до клинической валидации, регуляторных требований и безопасного деплоя в клиническую среду.',
    details:
        'Особое внимание уделяется интерпретируемости моделей, предвзятости данных и защите от атак на ИИ, от которых напрямую зависит безопасность пациентов.',
    photo: astantinPhoto,
  },
  {
    id: 'khokhlov',
    name: 'Хохлов Александр Леонидович',
    role: 'Ректор',
    org: 'Ярославский государственный медицинский университет',
    summary:
      'Спикер раскрывает этические аспекты искусственного интеллекта и значение национальной стратегии применения ИИ в здравоохранении.',
    details:
      'Фокус лекций - на балансе технологического развития, медицинской науки и ответственности перед пациентом.',
    photo: khokhlovPhoto,
  },
  {
    id: 'chuprov',
    name: 'Чупров Александр Владимирович',
    role: 'Начальник отдела информационной безопасности',
    org: 'ФГАУО ВО РНИМУ им. Н.И. Пирогова (Пироговский Университет)',
    summary:
        'Лекция описывает подходы к технической защите информации ограниченного доступа в современных условиях и даёт обзор нормативно-методической базы, определяющей требования к защите информации.',
    details:
        'Разбирается руководящая роль ФСТЭК России: ключевые механизмы контроля, надзора и регулирования, подходы к сертификации и лицензированию. Завершающая часть посвящена информационной безопасности при внедрении ИИ: методике анализа защищённости ИИ-систем, обрабатывающих данные ограниченного доступа.',
    photo: chuprovPhoto,
  },
  {
    id: 'fursov',
    name: 'Фурсов Константин Сергеевич',
    role: 'Директор Института мировой медицины',
    org: 'ФГАУО ВО РНИМУ им. Н.И. Пирогова (Пироговский Университет)',
    summary:
        'На лекции поговорим об этических вызовах и будущем врачебной профессии. Как перестать быть пассивным наблюдателем цифровой трансформации и стать ее осознанным со-творцом?',
    photo: fursovPhoto,
  },
];

function getOffset(index, activeIndex, total) {
  const forward = (index - activeIndex + total) % total;
  const backward = forward - total;
  return Math.abs(forward) <= Math.abs(backward) ? forward : backward;
}

function getCarouselState(offset, compact) {
  const sideOffset = compact ? 110 : 170;
  const farOffset = compact ? 184 : 288;

  if (offset === 0) {
    return { x: 0, y: 0, scale: 1, rotate: 0, opacity: 1, zIndex: 5, filter: 'blur(0px)' };
  }

  if (offset === 1) {
    return { x: sideOffset, y: 0, scale: compact ? 0.82 : 0.86, rotate: 0, opacity: 0.78, zIndex: 4, filter: 'blur(0.2px)' };
  }

  if (offset === -1) {
    return { x: -sideOffset, y: 0, scale: compact ? 0.82 : 0.86, rotate: 0, opacity: 0.78, zIndex: 4, filter: 'blur(0.2px)' };
  }

  if (offset === 2) {
    return { x: farOffset, y: 0, scale: 0.72, rotate: 0, opacity: compact ? 0 : 0.34, zIndex: 3, filter: 'blur(0.9px)' };
  }

  if (offset === -2) {
    return { x: -farOffset, y: 0, scale: 0.72, rotate: 0, opacity: compact ? 0 : 0.34, zIndex: 3, filter: 'blur(0.9px)' };
  }

  return {
    x: offset > 0 ? (compact ? 226 : 360) : compact ? -226 : -360,
    y: 0,
    scale: 0.56,
    rotate: 0,
    opacity: 0,
    zIndex: 1,
    filter: 'blur(3px)',
  };
}

export function Speakers() {
  const reduceMotion = useReducedMotion();
  const [activeIndex, setActiveIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const [compact, setCompact] = useState(false);

  useEffect(() => {
    const media = window.matchMedia('(max-width: 720px)');
    const sync = () => setCompact(media.matches);

    sync();

    if (media.addEventListener) {
      media.addEventListener('change', sync);
      return () => media.removeEventListener('change', sync);
    }

    media.addListener(sync);
    return () => media.removeListener(sync);
  }, []);

  useEffect(() => {
    if (reduceMotion || paused) return undefined;

    const timer = window.setInterval(() => {
      setActiveIndex((current) => (current + 1) % speakers.length);
    }, 5000);

    return () => window.clearInterval(timer);
  }, [paused, reduceMotion]);

  const activeSpeaker = speakers[activeIndex];

  const carouselItems = useMemo(
    () =>
      speakers.map((speaker, index) => ({
        ...speaker,
        index,
        offset: getOffset(index, activeIndex, speakers.length),
      })),
    [activeIndex]
  );

  return (
    <section
      className={`${ui.section} ${ui.sectionSeam} ${st.root}`}
    >
      <div className={ui.container}>
        <Reveal>
          <SectionHeader
            kicker="Спикеры"
            title="Спикеры курса"
            subtitle="Практики, исследователи и руководители здравоохранения, которые делятся реальным опытом применения ИИ в медицине."
          />
        </Reveal>

        <div
          className={st.layout}
          onMouseEnter={() => setPaused(true)}
          onMouseLeave={() => setPaused(false)}
        >
          <Reveal delay={0.05}>
            <div className={`${ui.card} ${st.stageCard}`}>
              <div className={st.stageGlow} aria-hidden="true" />
              <div className={st.stage}>
                <div className={st.trackGlow} aria-hidden="true" />
                <div className={st.track} aria-hidden="true" />

                {carouselItems.map((speaker) => {
                  const isActive = speaker.index === activeIndex;
                  const state = getCarouselState(speaker.offset, compact);
                  const { zIndex, ...motionState } = state;

                  return (
                    <div key={speaker.id} className={st.photoAnchor} style={{ zIndex }}>
                      <motion.button
                        type="button"
                        className={`${st.photoCard} ${isActive ? st.photoCardActive : ''}`}
                        onClick={() => setActiveIndex(speaker.index)}
                        aria-pressed={isActive}
                        animate={motionState}
                        initial={reduceMotion ? false : { opacity: 0, scale: 0.8, y: 24 }}
                        transition={reduceMotion ? { duration: 0 } : { duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                        whileHover={reduceMotion || isActive ? undefined : { y: -8, scale: (state.scale || 1) + 0.02 }}
                      >
                        <div className={st.photoFrame}>
                          <img src={speaker.photo} alt={speaker.name} className={st.photo} />
                          <div className={st.photoShade} aria-hidden="true" />
                        </div>

                        <div className={st.photoMeta}>
                          <div className={st.photoName}>{speaker.name}</div>
                          <div className={st.photoRole}>{speaker.role}</div>
                        </div>
                      </motion.button>
                    </div>
                  );
                })}
              </div>

            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className={`${ui.card} ${st.infoCard}`}>
              <div className={st.infoBodyTrack}>
                <AnimatePresence mode="wait">
                  <motion.div
                    key={activeSpeaker.id}
                    className={st.infoBody}
                    initial={reduceMotion ? { opacity: 1 } : { opacity: 0, y: 18 }}
                    animate={reduceMotion ? { opacity: 1 } : { opacity: 1, y: 0 }}
                    exit={reduceMotion ? { opacity: 1 } : { opacity: 0, y: -12 }}
                    transition={reduceMotion ? { duration: 0 } : { duration: 0.35, ease: 'easeOut' }}
                  >
                    <div className={st.speakerBlock}>
                      <div className={st.kicker}>О спикере</div>
                      <div className={st.name}>{activeSpeaker.name}</div>
                      <div className={st.role}>{activeSpeaker.role}</div>
                      {activeSpeaker.org ? <div className={st.org}>{activeSpeaker.org}</div> : null}
                    </div>

                    <div className={st.copy}>
                      <p>{activeSpeaker.summary}</p>
                      {activeSpeaker.details ? <p>{activeSpeaker.details}</p> : null}
                    </div>
                  </motion.div>
                </AnimatePresence>
              </div>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.14}>
          <div className={`${ui.card} ${st.selectorBand}`}>
            <div className={st.selectorBandHeader}>
              <div className={st.selectorBandTitle}>Все спикеры курса</div>
            </div>

            <div className={st.selectorRow}>
              {speakers.map((speaker, index) => {
                const selected = index === activeIndex;

                return (
                  <button
                    key={speaker.id}
                    type="button"
                    className={`${st.selector} ${selected ? st.selectorActive : ''}`}
                    onClick={() => setActiveIndex(index)}
                    aria-pressed={selected}
                  >
                    <span className={st.selectorName}>{speaker.name}</span>
                    <span className={st.selectorOrg}>{speaker.org || speaker.role}</span>
                  </button>
                );
              })}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
